var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"邀请供销商","visible":_vm.dialogVisible,"width":"600px","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('Invite')],1)}
var staticRenderFns = []

export { render, staticRenderFns }